import useAxiosService from './useAxiosService'
import { IClinicRoom, ICreateClinicRoom } from 'interfaces'
import { IResponse } from 'interfaces/services'

export const useClinicRoomService = () => {
  const { post, patch } = useAxiosService()
  const createClinicRoom = async (query: ICreateClinicRoom) => {
    const response: any = await post('/clinic-room/create', query)
    return {
      ...response,
      data: response.data?.major_id
    } as IResponse<number>
  }

  const updateClinicRoom = async (query: ICreateClinicRoom) => {
    const response: any = await patch('/clinic-room/update', query)
    return {
      ...response,
      data: response.data?.rooms
    } as IResponse<Array<IClinicRoom>>
  }

  const getClinicRooms = async (query?: any) => {
    const response: any = await post('/clinic-room/search', query)
    return {
      ...response,
      data: response.data?.rooms
    } as IResponse<Array<IClinicRoom>>
  }

  return {
    createClinicRoom,
    updateClinicRoom,
    getClinicRooms
  }
}
